import { render, staticRenderFns } from "./ClientSupplementsInstructionsItem.vue?vue&type=template&id=e6dd2b4e&scoped=true"
import script from "./ClientSupplementsInstructionsItem.vue?vue&type=script&lang=js"
export * from "./ClientSupplementsInstructionsItem.vue?vue&type=script&lang=js"
import style0 from "./ClientSupplementsInstructionsItem.vue?vue&type=style&index=0&id=e6dd2b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6dd2b4e",
  null
  
)

export default component.exports